import React from 'react';

/**
 * The ▲/▼ marker row under a `.condition-section` pattern box.
 *
 * One constant shared by every Insights panel that draws one — Immune (WBC),
 * Glucose, Thyroid, Stress & Adrenal, Iron and Hydration — so a panel added
 * later inherits the row the others already agreed on instead of restating it.
 *
 * There is deliberately NO fontWeight here. `.condition-section`
 * (bloodwork-anemia-status.css) sets `font-weight: bold` on the whole box and
 * the marker row inherits it, which is why five panels never mentioned weight
 * at all. Stress & Adrenal and Iron each shipped an explicit `fontWeight: 400`
 * that quietly opted their rows out, and that is the drift this constant and
 * pattern-box-marker-row.test.ts exist to stop. It is not only cosmetic: both
 * of those panels self-estimate their PDF height off PDF_CHAR_WIDTH 6.9, the
 * measured BOLD glyph width, so a row set lighter also makes its own page
 * arithmetic wrong.
 *
 * A new gauge panel gets its marker row by importing this. Nothing else about
 * the box needs a constant: the title and bullets inherit `.condition-section`
 * directly.
 */
export const MARKER_ROW_STYLE: React.CSSProperties = {
  color: '#000',
  textAlign: 'right',
};
